import store from '@/store';

/**
 * Central place for copilot product availability + virtual stock **data** updates over WebSocket.
 *
 * - **Action 15** (`ACTION_UPDATE_PRODUCT_AVAILABILITY`): legacy menu row availability (sku + category).
 * - **Action 27** (`ACTION_UPDATE_PRODUCT_VIRTUAL_STOCK`): per-venue virtual stock overlay (productId).
 *
 * **Audio / TTS notifications** (out of stock, low stock, etc.) are not handled here: they all use
 * `ACTION_SEND_NOTIFICATION` (7) with the same path as other copilot voice alerts
 * (`useNotificationStore` + `copilot/setNewNotification` in `BackendSyncService`).
 */

/**
 * @param {{ productSku: string, menuCategoryId: string|number, newAvailability: number }} payload
 */
export function applyMenuProductAvailabilityFromWebSocket({ productSku, menuCategoryId, newAvailability }) {
	store.commit('menu/updateProductAvailability', { productSku, menuCategoryId, newAvailability });
}

/**
 * @param {Object} stockRecord - Product virtual stock DTO (must include `productId`)
 */
export function applyProductVirtualStockFromWebSocket(stockRecord) {
	if (!stockRecord?.productId) {
		return;
	}
	import('@/stores/useProductStockStore')
		.then(({ useProductStockStore }) => {
			useProductStockStore().applyWebSocketUpdate(stockRecord);
		})
		.catch((e) => {
			console.warn('[copilotProductStockSync] Product stock store not available for virtual stock update', e);
		});
}
